import React, { useCallback, useState } from 'react'
import {
  StyledBqDropdown,
  StyledBqOption,
  StyledAvatar,
  StyledHeaderWrapper,
  StyledLink,
  StyledBqDivider,
  StyledBqButton,
  StyledWrapper,
  StyledIconBqButton
} from './styles'
import { BqIcon, BqOptionList } from '@beeq/react'
import { Text } from '../../constants/TextConstants'
import { useSave } from '../../Context/saveContext'
import { useMsal } from '@azure/msal-react'
import { loginRequest } from '../../authConfig'

export const Navbar = () => {
  const { instance } = useMsal()
  const { userProfile } = useSave()

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const openMenuHandler = () => setIsMenuOpen((prev) => !prev)

  const userInitials = userProfile?.name && userProfile?.lastName ? userProfile.name[0] + userProfile.lastName[0] : ''

  const handleLogout = useCallback(() => {
    instance.logoutRedirect(loginRequest).catch((e) => {
      console.error('Logout failed', e)
    })
  }, [instance, loginRequest])

  return (
    <>
      <StyledHeaderWrapper>
        <StyledLink to='/' data-testid='header-endava-profiles-logo'>
          {Text.LogoText}
        </StyledLink>
        <StyledWrapper>
          <StyledIconBqButton appearance='text'>
            <BqIcon name='bell' />
          </StyledIconBqButton>
          {userInitials && (
            <StyledBqDropdown
              open={isMenuOpen}
              onBqOpen={openMenuHandler}
              same-width
              placement='top-end'
              data-testid='header-user-menu'>
              <StyledBqButton slot='trigger' appearance='text' data-testid='header-user-menu-button'>
                <StyledAvatar slot='prefix' initials={userInitials} size='small' />
                <span data-testid='header-user-fullname'>{userProfile?.fullName || ''}</span>
                {isMenuOpen ? (
                  <BqIcon slot='suffix' name='caret-up' size='18' />
                ) : (
                  <BqIcon slot='suffix' name='caret-down' size='18' />
                )}
              </StyledBqButton>
              <BqOptionList role='listbox' data-testid='header-user-menu-option-list'>
                <StyledBqOption value='Logout' onBqClick={handleLogout}>
                  <BqIcon slot='prefix' name='sign-out' />
                  <span>{Text.LogoutButton}</span>
                </StyledBqOption>
              </BqOptionList>
            </StyledBqDropdown>
          )}
        </StyledWrapper>
      </StyledHeaderWrapper>
      <StyledBqDivider strokeThickness='1' />
    </>
  )
}
